export default defineNuxtRouteMiddleware(() => {
	const store = useUserStore()
	const localePath = useLocalePath()
	if (!store.state.user) {
		return navigateTo(localePath('/'))
	} else if (!store.getPermission([EUserPermissions.CMS_PL, EUserPermissions.CMS_EN])) {
		return navigateTo(localePath('/'))
	}
})
